import { LazyLoadImage } from "react-lazy-load-image-component";
import HomepageBg from "assets/images/homepage_bg.jpg";
import JLLLogo from "assets/images/jll_32_logo.svg";
import { SolButton, SolIcon } from "@solstice/sol-react";
import pkceChallenge from "pkce-challenge";
import Cookies from "js-cookie";
import oktaAuth from "oktaConfig";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useContext, useEffect } from "react";
import { GlobalContext } from "context";
import { SET_ALERT_MODAL } from "constant";
import AlertModal from "ui-molecules/Modals/AlertModal/AlertModal";

const OriginalHome = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { dispatch } = useContext(GlobalContext);
  const error = searchParams.get("error");

  const clearErrorParam = () => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.delete("error");
      return newParams;
    }
    );
  };

  useEffect(() => {
    if (error) {
      dispatch({
        type: SET_ALERT_MODAL,
        payload: {
          open: true,
          kind: "warn",
          title: "Error logging in",
          description:
            `There was an error logging in: ${error}. Please contact the site administrators.`,
          icon: "warning",
          btn1: {
            label: "Close",
            onClick: () => {
              clearErrorParam();
              dispatch({
                type: SET_ALERT_MODAL,
                payload: {
                  open: false,
                  kind: "",
                  title: "",
                  description: "",
                  icon: "",
                  btn1: null,
                  btn2: null,
                  btn3: null,
                },
              });
            },
          },
        },
      });
    }
  }, [error]);

  const generateUrlSafeToken = (length: number) => {
    const array: any = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
      .replace(/\+/g, "-") // Replace '+' with '-'
      .replace(/\//g, "_") // Replace '/' with '_'
      .replace(/=+$/, ""); // Remove '=' padding
  };
  const handleLogin = async () => {
    const { code_verifier, code_challenge } = await pkceChallenge();
    const state = generateUrlSafeToken(32);
    const nonce = generateUrlSafeToken(32);

    await Cookies.set("state", state);
    await Cookies.set("nonce", nonce);
    await Cookies.set("code_verifier", code_verifier);

    try {
      const redirectUri = `${location.pathname}${location?.search}`;
      localStorage.setItem("redirectUri", redirectUri);
      await oktaAuth.signInWithRedirect({
        codeChallenge: code_challenge,
        codeVerifier: code_verifier,
        state,
        nonce,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="w-full h-full flex flex-row">
      <div className="flex flex-col justify-center h-full bg-jll-surface-base-default px-[72px] text-white">
        <div className="w-full mb-12">
          <LazyLoadImage src={JLLLogo} />
        </div>
        <h2 className="text-3xl whitespace-nowrap mb-2">Profile management</h2>
        <div className="text-xl whitespace-nowrap mb-2">
          <p>JLL's home to manage broker profile data and</p>
          <p>related metadata</p>
        </div>
        <p className="text-sm mb-12">
          Manage your data and sync your changes to external systems
        </p>
        <SolButton size="large" onSol-click={handleLogin}>
          Login
          <SolIcon icon="login" />
        </SolButton>
      </div>
      <div className="w-full h-full">
        <LazyLoadImage
          src={HomepageBg}
          className="h-full w-full object-cover"
        />
      </div>
      <AlertModal />
    </div>
  );
};

export default OriginalHome;
